/* eslint-disable @angular-eslint/no-input-rename */
import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";

import { CarouselElementType } from "../carousel-element.component";

import { CarouselElementSlideService } from "./carousel-element-slide.service";

@Component({
  selector: "carousel-element-slide",
  templateUrl: "./carousel-element-slide.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselElementSlideElement implements OnInit {
  /** Image alt text for slide */
  @Input("image-alt") imageAlt?: string;

  /** Image source for slide */
  @Input("image-src") imageSrc?: string;

  type!: CarouselElementType;

  @ViewChild(TemplateRef) templateRef!: TemplateRef<CarouselElementSlideElement>;

  constructor(
    public readonly elementRef: ElementRef,
    private readonly carouselElementSlideService: CarouselElementSlideService
  ) {}

  ngOnInit(): void {
    this.carouselElementSlideService.setSlide(this);
  }
}
